class ResponsiveSizeHelper {
  public isNarrowWidth(width: number) {
    return width < 768;
  }
}

export const ResponsiveSizeUtility = new ResponsiveSizeHelper();
